<template>
  <div class="road">
    <div class="layer">
      <div class="roadDetail">
        <div class="title">
          <h1>
            中国工程科技研究机构与专家库
            <p>一带一路主题内容</p>
          </h1>
        </div>
        <div class="paragraph">
          <h2>什么是“一带一路” ？</h2>
          <p>
            2013年9月7日，国家主席习近平在哈萨克斯坦纳扎尔巴耶夫大学作题为《弘扬人民友谊 共创美好未来》的演讲，提出共同建设
            <span>“丝绸之路经济带”。</span>
          </p>
          <p>
            2013年10月3日，习近平主席在印度尼西亚国会发表题为《携手建设中国—东盟命运共同体》的演讲，提出共同建设
            <span>“21世纪海上丝绸之路”。</span>
          </p>
          <p>
            <span>“丝绸之路经济带”</span>和
            <span>“21世纪海上丝绸之路”</span>简称
            <span>“一带一路”倡议。</span>
          </p>
        </div>
        <div class="paragraph">
          <h2>在学术领域的“一带一路”</h2>
          <p>中国工程科技研究机构与专家库（后简称为专家库），国家工程科技思想库基础建设之一，中国工程科技知识中心建设，是一个以服务与应用为目标的建设和研究综合项目。</p>
          <p>本次，专家库将就项目已有数据，为您揭示学术领域那些“一带一路”的聚焦点、研究者和研究机构。</p>
        </div>
        <div class="paragraph">
          <h2>“一带一路”研究热点</h2>
          <p>首先，我们向大家展示的是“一带一路”学术研究上的相关数据：</p>
          <h3>1.“一带一路”在本项目中的最早记录：</h3>
          <p>经过查询，最早由黑龙江省农垦牡丹江管理局于2014年在期刊《农场经济管理》中撰写《奏响中俄邦交“新友谊”谱写“丝绸之路”新篇章——黑龙江省农垦牡丹江管理局关于“一带一路”建设的发展思路》一文，抢下了第一的先手位置。</p>
          <h3>2.“一带一路”研究的趋势：</h3>
          <p>在专家库的数据中，“一带一路”今年始终以一个较高的增长率在中文期刊论文中出现（如图1所示，2019年数据量较低因2019年数据暂未获取）。</p>
        </div>
        <div class="bar">
          <RoadBarChart></RoadBarChart>
        </div>
        <div class="paragraph">
          <h5>图1“一带一路”在中文期刊论文中作为关键词出现次数历年统计</h5>
          <p>然后，让我们将数据进行一定的拆解，通过“一带一路”与学科、期刊、年份进行对应。我们获得了如图2所示的“一带一路”涉及领域的直观展示。</p>
        </div>
        <div class="sankey">
          <sankey-Chart :sankeyList="sankeyList" id="EXPChart" height="100%" width="100%" />
        </div>
        <div class="paragraph">
          <h5>图2“一带一路”在学科领域、期刊、年份中联系变化桑基图</h5>
          <h3>3.“一带一路”高度关联的研究聚焦</h3>
          <p>在看了“一带一路”作为关键词的宏观展示后，让我们来更深入的了解一下那些与“一带一路”直接关联的关键词。在这里我们已经为您做了如下图3的简单聚类。</p>
          <p>就像您所看到的，由习大大所倡议的“一带一路”最直接关联的就是“一带一路倡议”、“一带一路战略”、“中国”、“对策”、“发展”等宏观词汇，但是我们也可以发现一带一路在“对外直接投资”、“人民币国际化”、 “走出去”等更具象化的内容上也被更多的专家学者关注。人们对“一带一路”正在逐渐从宏观概念转向具象实际的内容。</p>
        </div>
        <div class="world">
          <RoadWorldChart :WordCloudList="WordCloudList2"></RoadWorldChart>
        </div>
        <div class="paragraph">
          <h5>图3“一带一路”直接高频关联的关键词词云图</h5>
        </div>

        <div class="cloud">
          <CloudChart></CloudChart>
        </div>
        <div class="paragraph">
          <h5>图4“一带一路”高频关联关键词一维关系图</h5>
          <h2>“一带一路”研究者</h2>
          <p>经过了上面的介绍，相信大家也对“一带一路”的研究状况有了一个相对清晰的了解，那么不禁有一个疑问，是哪些研究者在研究“一带一路”呢？</p>
          <p>那让我们来做一个简单的挖掘：将图3中关键词对专家库现有专家进行过滤，然后对专家按“一带一路”提出频次进行降序，然后我们可以获得如下表1的专家数据（因篇幅有限，正文仅展示top20，排名按关联频次降序后姓名按拼音首字母排序）</p>
        </div>
        <div class="table">
          <template>
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
              <el-table-column prop="name" label="专家姓名" width="500"></el-table-column>
              <el-table-column prop="org" label="所在机构" width="700"></el-table-column>
              <el-table-column prop="num" label="关联频次"></el-table-column>
            </el-table>
          </template>
        </div>
        <div class="paragraph">
          <h5>表1“一带一路”高频发文作者</h5>
          <h2>“一带一路”研究机构</h2>
          <p>同研究者，我们也对“一带一路”的研究机构进行了挖掘，如下图4 所示</p>
        </div>
        <div class="world">
          <RoadWorldChart :WordCloudList="WordCloudList1"></RoadWorldChart>
        </div>
        <div class="paragraph">
          <h5>图4“一代一路”主要研究机构</h5>
          <p>“一带一路”Top10研究机构历年发文：</p>
        </div>
        <div class="table">
          <template>
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
              <el-table-column prop="name" label="专家姓名" width="500"></el-table-column>
              <el-table-column prop="org" label="所在机构" width="700"></el-table-column>
              <el-table-column prop="num" label="关联频次"></el-table-column>
            </el-table>
          </template>
        </div>
        <div class="paragraph">
          <p>“可视化折线图：</p>
        </div>
        <div class="fold">
          <FoldLineChart :foldList="foldList"></FoldLineChart>
        </div>
        <div class="paragraph">
          <p>附1：</p>
          <h5>“一带一路”高频发文作者TOP50</h5>
        </div>
        <div class="table">
          <template>
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
              <el-table-column prop="name" label="专家姓名" width="500"></el-table-column>
              <el-table-column prop="org" label="所在机构" width="700"></el-table-column>
              <el-table-column prop="num" label="关联频次"></el-table-column>
            </el-table>
          </template>
        </div>
        <div class="paragraph">
          <p>附2：</p>
          <h5>“一带一路”研究机构TOP50</h5>
        </div>
        <div class="table">
          <template>
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
              <el-table-column prop="name" label="专家姓名" width="500"></el-table-column>
              <el-table-column prop="org" label="所在机构" width="700"></el-table-column>
              <el-table-column prop="num" label="关联频次"></el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FoldLineChart from '@/components/Charts/FoldLineChart';
import RoadWorldChart from '@/components/Charts/RoadWorldChart';
import CloudChart from '@/components/Charts/CloudChart';
import RoadBarChart from '@/components/Charts/RoadBarChart';
import sankeyChart from '@/components/Charts/sankeyChart';
export default {
  name: 'road',
  components: {
    FoldLineChart,
    RoadWorldChart,
    CloudChart,
    RoadBarChart,
    sankeyChart
  },
  data () {
    return {
      foldList: {
        data: [
          {
            name: '中国社会科学院',
            data: [
              { year: 2019, count: 300 },
              { year: 2018, count: 250 },
              { year: 2017, count: 178 },
              { year: 2016, count: 150 },
              { year: 2015, count: 100 }
            ]
          },
          {
            name: '中国人民大学',
            data: [
              { year: 2019, count: 350 },
              { year: 2018, count: 276 },
              { year: 2017, count: 200 },
              { year: 2016, count: 122 },
              { year: 2015, count: 92 }
            ]
          },
          {
            name: '武汉大学',
            data: [
              { year: 2019, count: 340 },
              { year: 2018, count: 256 },
              { year: 2017, count: 135 },
              { year: 2016, count: 111 },
              { year: 2015, count: 55 }
            ]
          },
          {
            name: '对外经济贸易大学',
            data: [
              { year: 2019, count: 290 },
              { year: 2018, count: 320 },
              { year: 2017, count: 240 },
              { year: 2016, count: 123 },
              { year: 2015, count: 22 }
            ]
          },
          {
            name: '中国科学院',
            data: [
              { year: 2019, count: 255 },
              { year: 2018, count: 270 },
              { year: 2017, count: 124 },
              { year: 2016, count: 145 },
              { year: 2015, count: 55 }
            ]
          },
          {
            name: '北京大学',
            data: [
              { year: 2019, count: 288 },
              { year: 2018, count: 277 },
              { year: 2017, count: 134 },
              { year: 2016, count: 146 },
              { year: 2015, count: 66 }
            ]
          },
          {
            name: '北京师范大学',
            data: [
              { year: 2019, count: 337 },
              { year: 2018, count: 243 },
              { year: 2017, count: 157 },
              { year: 2016, count: 178 },
              { year: 2015, count: 24 }
            ]
          },
          {
            name: '四川大学',
            data: [
              { year: 2019, count: 320 },
              { year: 2018, count: 233 },
              { year: 2017, count: 135 },
              { year: 2016, count: 189 },
              { year: 2015, count: 75 }
            ]
          },
          {
            name: '清华大学',
            data: [
              { year: 2019, count: 344 },
              { year: 2018, count: 220 },
              { year: 2017, count: 142 },
              { year: 2016, count: 199 },
              { year: 2015, count: 12 }
            ]
          },
          {
            name: '浙江大学',
            data: [
              { year: 2019, count: 400 },
              { year: 2018, count: 330 },
              { year: 2017, count: 199 },
              { year: 2016, count: 201 },
              { year: 2015, count: 99 }
            ]
          }
        ],
        yearMax: 2019,
        yearMin: 2015
      },
      WordCloudList1: [
        { name: '一带一路', value: 235 },
        { name: '“一带一路”倡议', value: 177 },
        { name: '“一带一路”战略', value: 122 },
        { name: '对外直接投资', value: 105 },
        { name: '中国', value: 102 },
        { name: '人类命运共同体', value: 91 },
        { name: '“一带一路”建设', value: 89 },
        { name: '全球治理', value: 55 },
        { name: '对策', value: 54 },
        { name: '互联互通', value: 53 },
        { name: '全球化', value: 53 },
        { name: '国际化', value: 50 },
        { name: '丝绸之路', value: 47 },
        { name: '人民币国际化', value: 47 },
        { name: '全球价值链', value: 46 },
        { name: '引力模型', value: 46 },
        { name: '基础设施', value: 44 },
        { name: '走出去', value: 44 },
        { name: '产能合作', value: 37 },
        { name: '东盟', value: 35 },
        { name: '命运共同体', value: 35 },
        { name: '地缘政治', value: 35 },
        { name: '挑战', value: 33 },
        { name: '印度', value: 32 },
        { name: '贸易潜力', value: 32 },
        { name: '人才培养', value: 31 },
        { name: '高等教育', value: 31 },
        { name: '国际合作', value: 30 },
        { name: '新疆', value: 30 },
        { name: '国际产能合作', value: 28 },
        { name: '对外开放', value: 28 },
        { name: '“走出去”', value: 27 },
        { name: '中亚', value: 27 },
        { name: '文化产业', value: 27 },
        { name: '制造业', value: 26 },
        { name: '国际贸易', value: 26 },
        { name: '日本', value: 26 },
        { name: '机遇', value: 26 },
        { name: '策略', value: 26 },
        { name: '东南亚', value: 25 },
        { name: '对外贸易', value: 25 },
        { name: '海上丝绸之路', value: 25 },
        { name: '跨境电商', value: 25 },
        { name: 'OFDI', value: 24 },
        { name: '丝绸之路经济带', value: 24 },
        { name: '区域合作', value: 24 }
      ],
      WordCloudList2: [
        { name: '中国社会科学院', value: 88 },
        { name: '中国人民大学', value: 52 },
        { name: '武汉大学', value: 33 },
        { name: '对外经济贸易大学', value: 30 },
        { name: '中国科学院', value: 29 },
        { name: '北京大学', value: 28 },
        { name: '南开大学', value: 28 },
        { name: '北京师范大学', value: 21 },
        { name: '四川大学', value: 20 },
        { name: '清华大学', value: 19 },
        { name: '吉林大学', value: 17 },
        { name: '新疆大学', value: 17 },
        { name: '浙江大学', value: 17 },
        { name: '暨南大学', value: 15 },
        { name: '西北大学', value: 15 },
        { name: '中国社会科学院亚太与全球战略研究院', value: 14 },
        { name: '南京大学', value: 14 },
        { name: '复旦大学', value: 14 },
        { name: '上海社会科学院', value: 13 },
        { name: '中国国际经济交流中心', value: 13 },
        { name: '中央民族大学', value: 13 },
        { name: '华东师范大学', value: 13 },
        { name: '广东外语外贸大学', value: 13 },
        { name: '云南大学', value: 12 },
        { name: '外交学院', value: 12 },
        { name: '上海外国语大学', value: 11 },
        { name: '中国农业大学', value: 11 },
        { name: '北京外国语大学', value: 11 },
        { name: '华南师范大学', value: 11 },
        { name: '南京师范大学', value: 11 },
        { name: '上海对外经贸大学', value: 10 },
        { name: '中国政法大学', value: 10 },
        { name: '厦门大学', value: 10 },
        { name: '新疆财经大学', value: 10 },
        { name: '辽宁大学', value: 10 },
        { name: '商务部国际贸易经济合作研究院', value: 9 },
        { name: '中国传媒大学', value: 8 },
        { name: '中央财经大学', value: 8 },
        { name: '山东财经大学', value: 8 },
        { name: '武汉理工大学', value: 8 },
        { name: '河海大学', value: 8 },
        { name: '西安交通大学', value: 8 },
        { name: '上海国际问题研究院', value: 7 },
        { name: '上海大学', value: 7 },
        { name: '上海海事大学', value: 7 },
        { name: '中国人民大学国际关系学院', value: 7 },
        { name: '中国人民大学经济学院', value: 7 },
        { name: '中国石油大学', value: 7 },
        { name: '中山大学', value: 7 },
        { name: '华中师范大学', value: 7 }
      ],
      sankeyList: {
        links: [
          { source: '一带一路', target: '经济学', value: 3003 },
          { source: '一带一路', target: '世界经济学', value: 2003 },
          { source: '一带一路', target: '教育学', value: 103 },
          { source: '一带一路', target: '语言学', value: 303 },
          { source: '一带一路', target: '政治学', value: 33 },
          { source: '一带一路', target: '法学', value: 33 },
          { source: '一带一路', target: '商业学', value: 33 },
          { source: '一带一路', target: '民族学与文化学', value: 33 }
        ],
        nodes: [
          { name: '一带一路' },
          { name: '经济学' },
          { name: '世界经济学' },
          { name: '教育学' },
          { name: '语言学' },
          { name: '政治学' },
          { name: '法学' },
          { name: '商业经济学' },
          { name: '民族学与文化学' }
        ]
      },
      tableData: [
        {
          org: '中国人民大学国际关系学院',
          name: '王椅栀',
          num: '13'
        },
        {
          org: '中国社会科学院 ',
          name: '沈铭辉',
          num: '8'
        },
        {
          org: '中国科学院',
          name: '刘卫东',
          num: '6'
        },
        {
          org: '中国社会科学院',
          name: '姚站琪',
          num: '6'
        }
      ]
    }
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    }
  }
}
</script>

<style lang="scss">
.roadDetail {
  padding: 0 5vw;
  background: white;
  padding-top: 2vh;
  .title {
    text-align: center;
  }
  .paragraph {
    margin-top: 2vh;
    h1 {
      margin-top: 2vh;
      font-size: 2.5em;
    }
    h3 {
      margin-top: 2vh;
      text-indent: 2em;
    }
    h5 {
      text-align: center;
    }
    p {
      margin-top: 2vh;
      text-indent: 2em;
      span {
        color: rgb(237, 125, 49);
      }
    }
  }
  .fold {
    margin: 2vh 0;
    height: 70vh;
  }
  .sankey {
    margin: 2vh 0;
    height: 70vh;
  }
  .world {
    margin: 2vh 0;
    height: 40vh;
  }
  .cloud {
    margin: 2vh 0;
    height: 70vh;
  }
  .bar {
    margin: 2vh 0;
    height: 70vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/road/road.vue